export interface GoddessWork {
  id: string;
  title: string;
  category: string;
  subtitle: string;
  cover: string;
  description: string;
  year: string;
  theme: string;
}

export const works: GoddessWork[] = [
  {
    id: "xingqiong",
    title: "星穹之下",
    category: "奇幻恋爱",
    subtitle: "群星铸就的神明谱系",
    cover: "https://readdy.ai/api/search-image?query=ethereal%20star%20goddess%20celestial%20realm%20at%20night%20with%20glowing%20golden%20constellations%20and%20swirling%20nebula%20above%20a%20starry%20dome%2C%20dreamy%20fantasy%20anime%20key%20visual%2C%20warm%20amber%20and%20crimson%20accents%2C%20luminous%20particles%2C%20elegant%20ethereal%20atmosphere&width=1200&height=800&seq=work-xingqiong-1&orientation=landscape",
    description: "当苍穹诸神逐一觉醒，一名误入星界的少女，在织星者的指引下揭开星辰神系的古老秘密。本作以「星神」为谱系，塑造了织星、夜临、北辰等多位人气女神角色。",
    year: "2021",
    theme: "星空 / 宿命 / 神明觉醒",
  },
  {
    id: "yuehua",
    title: "月华祭典",
    category: "和风奇幻",
    subtitle: "月下的平安夜宴",
    cover: "https://readdy.ai/api/search-image?query=ancient%20japanese%20moonlight%20festival%20at%20night%20with%20torii%20gate%20lanterns%20and%20blooming%20cherry%20blossoms%20under%20a%20huge%20pale%20moon%2C%20elegant%20wafu%20fantasy%20anime%20scene%2C%20warm%20vermilion%20and%20soft%20gold%20tones%2C%20mystical%20fireflies%2C%20refined%20atmosphere&width=1200&height=800&seq=work-yuehua-2&orientation=landscape",
    description: "以平安时代为背景的和风神话，讲述月神与霞神在一年一度的月华祭典中守护人间安宁的故事。月见、绛云等角色以温婉与风骨并存的设定广受好评。",
    year: "2019",
    theme: "和风 / 神话 / 祭典",
  },
  {
    id: "jileshengyu",
    title: "极乐圣域",
    category: "西方奇幻",
    subtitle: "光与晨曦的至高殿堂",
    cover: "https://readdy.ai/api/search-image?query=majestic%20celestial%20cathedral%20of%20dawn%20goddess%20with%20marble%20pillars%20stained%20glass%20and%20radiant%20golden%20light%20beams%2C%20high%20fantasy%20anime%20key%20visual%2C%20ivory%20and%20gold%20with%20crimson%20banners%2C%20divine%20holy%20atmosphere%2C%20breathtaking%20scale&width=1200&height=800&seq=work-jile-3&orientation=landscape",
    description: "在极乐圣域的十二神座中，晨曦、雷霆与花之女神各执一柄权柄。故事围绕神座继承与圣域存亡展开，女神角色的宿命与抉择成为最大看点。",
    year: "2022",
    theme: "西幻 / 神权 / 圣域",
  },
  {
    id: "huanghun",
    title: "黄昏契约",
    category: "都市奇幻",
    subtitle: "都市神明的黄昏誓约",
    cover: "https://readdy.ai/api/search-image?query=modern%20city%20skyline%20at%20dusk%20with%20a%20mysterious%20goddess%20silhouette%20among%20glowing%20skyscrapers%2C%20urban%20fantasy%20anime%20scene%2C%20warm%20orange%20and%20deep%20crimson%20twilight%20palette%2C%20cinematic%20light%2C%20elegant%20mysterious%20mood&width=1200&height=800&seq=work-huanghun-4&orientation=landscape",
    description: "当神明隐于喧嚣都市，雪与梦的契约悄然缔结。本作将神话融入现代生活，雪音、幽梦等角色在人间与神域之间游走，人气居高不下。",
    year: "2020",
    theme: "都市 / 契约 / 双面神格",
  },
  {
    id: "canglan",
    title: "苍蓝神殿",
    category: "海洋神话",
    subtitle: "深蓝之下的古老神殿",
    cover: "https://readdy.ai/api/search-image?query=underwater%20ancient%20temple%20of%20the%20sea%20goddess%20with%20coral%20pillars%20schools%20of%20glowing%20fish%20and%20rays%20of%20light%20through%20deep%20blue%20water%2C%20ocean%20myth%20fantasy%20anime%20key%20visual%2C%20teal%20turquoise%20and%20soft%20gold%20accents%2C%20serene%20majestic%20underwater%20atmosphere&width=1200&height=800&seq=work-canglan-5&orientation=landscape",
    description: "潜入深蓝之下的苍蓝神殿，海洋女神与潮汐女神守护着这片古老海域。作品以瑰丽的水下场景与克制的角色塑造，在海洋神话题材中独树一帜。",
    year: "2018",
    theme: "海洋 / 守护 / 神话",
  },
];

export const getWork = (id: string): GoddessWork | undefined =>
  works.find((w) => w.id === id);